
            const data = {"name":"check","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M25.18 54l-13.8-23.28A4.9 4.9 0 0113.09 24a4.89 4.89 0 016.69 1.71l5.29 8.92L40.19 8.44a4.88 4.88 0 016.66-1.79 4.88 4.88 0 011.8 6.66z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                